import { Stack } from '@chakra-ui/react';
import React from 'react';
import EmailsForReview from '../features/emails-for-review/EmailsForReview';

const EmailsForReviewPage = () => {

    return (
        <Stack gap={5}>
            <EmailsForReview />
        </Stack>
    )
}

export default EmailsForReviewPage;